export function updateData(array) {
    for (let data of array) {
        data.value = data.dominance;
        delete data.dominance;
    }
}